module.exports = __webpack_public_path__ + "img/ot-xjoe_usdc.3e6115f3.png";